// import local from './local/local';
import control from './control/control';

// export default local;
export default control;
